/**
 * AIチャット関連のユーティリティ関数
 */

/**
 * userごとにスコープされたキーを生成
 * @param {string} uid - ユーザーID
 * @returns {string|null} キー
 */
export function convKey(uid) {
    return uid ? `ai:conv:${uid}` : null;
}

/**
 * メッセージ用のキーを生成
 * @param {string} uid - ユーザーID
 * @returns {string|null} キー
 */
export function msgsKey(uid) {
    return uid ? `ai:msgs:${uid}` : null;
}

/**
 * 削除されたメッセージ用のキーを生成
 * @param {string} uid - ユーザーID
 * @param {string} cid - 会話ID
 * @returns {string|null} キー
 */
export function deletedMsgsKey(uid, cid) {
    return uid && cid ? `ai:deleted:${uid}:${cid}` : null;
}

/**
 * ユーザーの削除メッセージ記録をすべて消す
 * @param {string} uid - ユーザーID
 */
export function clearDeletedMessageKeys(uid) {
    if (!uid) return;
    try {
        const keys = Object.keys(localStorage);
        keys.forEach((key) => {
            if (key.startsWith(`ai:deleted:${uid}:`)) {
                localStorage.removeItem(key);
            }
        });
    } catch (_) {
        // noop
    }
}

/**
 * 会話関連のローカルストレージをクリア
 * @param {string} uid - ユーザーID
 */
export function clearConversationLocalStorage(uid) {
    if (!uid) return;
    try {
        localStorage.removeItem(convKey(uid));
        localStorage.removeItem(msgsKey(uid));
        clearDeletedMessageKeys(uid);
    } catch (_) {
        // noop
    }
}

const PENDING_RESET_KEY = 'ai:pendingResetConversation';

/**
 * 地図の「AI会話」などから新しい会話へ遷移する直前に立てるフラグ
 */
export function markResetConversation() {
    try {
        sessionStorage.setItem(PENDING_RESET_KEY, '1');
    } catch (_) {
        // noop
    }
}

export function clearResetConversationMark() {
    try {
        sessionStorage.removeItem(PENDING_RESET_KEY);
    } catch (_) {
        // noop
    }
}

/**
 * ピン等からの新規会話リセット待ちか（sessionStorage のみ）
 * @returns {boolean}
 */
export function shouldResetConversation() {
    if (typeof window === 'undefined') return false;
    try {
        return sessionStorage.getItem(PENDING_RESET_KEY) === '1';
    } catch (_) {
        return false;
    }
}
